import { reverse } from 'named-urls'
import type { Location } from 'react-router-dom'

import type { LocationState } from '@types'
import { routing } from '@utils/routing'

export const createReportLink =
  ({ label, location }: { label: string; location: Location }) =>
  (reportId: string) => ({
    to: {
      pathname: reverse(routing.analyticsV2.reports.report.self, {
        reportId,
      }),
      search: location.search,
    },
    state: {
      from: { label, location },
    } satisfies LocationState,
  })
